// GET BLOG POSTS
export const GET_BLOG_POSTS_LOADING = "GET_BLOG_POSTS_LOADING";
export const GET_BLOG_POSTS_SUCCESS = "GET_BLOG_POSTS_SUCCESS";
export const GET_BLOG_POSTS_FAIL = "GET_BLOG_POSTS_FAIL";
export const GET_BLOG_POSTS_RESET = "GET_BLOG_POSTS_RESET";

// GET BLOG POSTS BY CATEGORY
export const GET_BLOG_POSTS_BY_CATEGORY_LOADING =
  "GET_BLOG_POSTS_BY_CATEGORY_LOADING";
export const GET_BLOG_POSTS_BY_CATEGORY_SUCCESS =
  "GET_BLOG_POSTS_BY_CATEGORY_SUCCESS";
export const GET_BLOG_POSTS_BY_CATEGORY_FAIL =
  "GET_BLOG_POSTS_BY_CATEGORY_FAIL";
export const GET_BLOG_POSTS_BY_CATEGORY_RESET =
  "GET_BLOG_POSTS_BY_CATEGORY_RESET";

// GET TOP BLOG POSTS THIS MONTH
export const GET_TOP_BLOG_POSTS_THIS_MONTH_LOADING =
  "GET_TOP_BLOG_POSTS_THIS_MONTH_LOADING";
export const GET_TOP_BLOG_POSTS_THIS_MONTH_SUCCESS =
  "GET_TOP_BLOG_POSTS_THIS_MONTH_SUCCESS";
export const GET_TOP_BLOG_POSTS_THIS_MONTH_FAIL =
  "GET_TOP_BLOG_POSTS_THIS_MONTH_FAIL";
export const GET_TOP_BLOG_POSTS_THIS_MONTH_RESET =
  "GET_TOP_BLOG_POSTS_THIS_MONTH_RESET";

// GET POST COMMENTS
export const GET_POST_COMMENTS_LOADING = "GET_POST_COMMENTS_LOADING";
export const GET_POST_COMMENTS_SUCCESS = "GET_POST_COMMENTS_SUCCESS";
export const GET_POST_COMMENTS_FAIL = "GET_POST_COMMENTS_FAIL";
export const GET_POST_COMMENTS_RESET = "GET_POST_COMMENTS_RESET";

// POST COMMENT
export const POST_COMMENT_LOADING = "POST_COMMENT_LOADING";
export const POST_COMMENT_SUCCESS = "POST_COMMENT_SUCCESS";
export const POST_COMMENT_FAIL = "POST_COMMENT_FAIL";

// GET BLOG POST
export const GET_BLOG_POST_LOADING = "GET_BLOG_POST_LOADING";
export const GET_BLOG_POST_SUCCESS = "GET_BLOG_POST_SUCCESS";
export const GET_BLOG_POST_FAIL = "GET_BLOG_POST_FAIL";
export const GET_BLOG_POST_RESET = "GET_BLOG_POST_RESET";

// GET RELATED BLOG POSTS
export const GET_RELATED_BLOG_POSTS_LOADING = "GET_RELATED_BLOG_POSTS_LOADING";
export const GET_RELATED_BLOG_POSTS_SUCCESS = "GET_RELATED_BLOG_POSTS_SUCCESS";
export const GET_RELATED_BLOG_POSTS_FAIL = "GET_RELATED_BLOG_POSTS_FAIL";
export const GET_RELATED_BLOG_POSTS_RESET = "GET_RELATED_BLOG_POSTS_RESET";

// GET LATEST BLOG POSTS
export const GET_LATEST_BLOG_POSTS_LOADING = "GET_LATEST_BLOG_POSTS_LOADING";
export const GET_LATEST_BLOG_POSTS_SUCCESS = "GET_LATEST_BLOG_POSTS_SUCCESS";
export const GET_LATEST_BLOG_POSTS_FAIL = "GET_LATEST_BLOG_POSTS_FAIL";
export const GET_LATEST_BLOG_POSTS_RESET = "GET_LATEST_BLOG_POSTS_RESET";
